import { SkuFilters } from "../interfaces/sku.interface";

// eslint-disable-next-line no-shadow
export enum SkuSortTypeEnum {
  HIGHER_PRICE = "higher_price",
  LOWER_PRICE = "lower_price",
  HIGHER_CC = "higher_cc",
  LOWER_CC = "lower_cc",
}

export type SelectedSkuFilters = {
  brand?: string;
  model?: string;
  year?: number;
  cc?: number;
  minPrice?: number;
  maxPrice?: number;
  searchText?: string;
  sort?: SkuSortTypeEnum;
};

export type SkuFilterOptions = {
  brands: string[];
  models: string[];
  years: number[];
  ccs: number[];
  priceMin: number | null;
  priceMax: number | null;
};

const SORT_TO_SERVER: Record<SkuSortTypeEnum, string> = {
  [SkuSortTypeEnum.HIGHER_PRICE]: "-minPrice",
  [SkuSortTypeEnum.LOWER_PRICE]: "minPrice",
  [SkuSortTypeEnum.HIGHER_CC]: "-cc",
  [SkuSortTypeEnum.LOWER_CC]: "cc",
};

export const toServerFilters = (
  filters: SelectedSkuFilters,
  page: number,
  limit: number
): Partial<SkuFilters> => ({
  brandName: filters.brand,
  modelName: filters.model,
  year: filters.year,
  cc: filters.cc,
  minPrice: filters.minPrice,
  maxPrice: filters.maxPrice,
  searchText: filters.searchText,
  sort: filters.sort ? SORT_TO_SERVER[filters.sort] : undefined,
  page,
  limit,
});
